export default "__VITE_ASSET__D3AH27VV__"